// Task Component Constants
// This file contains all dimensional, timing, and visual constants used across task components

// === Layout & Dimensions ===

// Task item dimensions
export const TASK_ITEM_HEIGHT = 60
export const TASK_ITEM_HEIGHT_CLASSNAME = `h-[${TASK_ITEM_HEIGHT}px]`
export const TASK_ITEM_MAX_HEIGHT_CLASSNAME = `max-h-[${TASK_ITEM_HEIGHT}px]`

// Day column dimensions
export const DAY_COLUMN_WIDTH = 280 // Width of each day column in desktop view
export const DAY_COLUMN_MIN_WIDTH = 280 // Minimum width for day columns

// Mobile layout dimensions
export const MOBILE_SECTION_MARGIN = 16 // Bottom margin for mobile day sections
export const MOBILE_HEADER_HEIGHT = 72 // Mobile day header height including padding
export const MOBILE_TASK_HEIGHT = 64 // Mobile task item height including margins
export const MOBILE_EMPTY_STATE_HEIGHT = 56 // Mobile empty state text height

// === Timing & Animation ===

// Drag and drop
export const DRAG_ANIMATION_DURATION = 200 // Duration in ms for displacement animation
export const DRAG_SAVE_DEBOUNCE = 0 // Debounce in ms for saving drag operations
export const DRAG_SCROLL_TIMEOUT = 1000 // Timeout in ms for manual scroll detection

// Loading states
export const LOADING_DELAY = 500 // Delay before showing loading state
export const SCROLL_THROTTLE = 16 // Scroll event throttle in ms
export const SCROLL_STOP_DELAY = 150 // Delay in ms to detect when scrolling has stopped

// === Visual Constants ===

// Drag state styling
export const DRAGGED_ITEM_OPACITY = 0.3 // Opacity for item being dragged
export const NORMAL_ITEM_OPACITY = 1.0 // Normal opacity for items

// === Data & Range Constants ===

// Desktop view
export const VISIBLE_DAYS_RANGE = 200 // Number of days to render on each side of selected date
export const DATE_RANGE_BUFFER = 3 // Buffer days before regenerating date range

// Mobile view
export const MOBILE_DAYS_RANGE = 30 // Number of days to show before and after current date

// === Hit Areas ===

// Touch targets
export const HIT_SLOP_SMALL = 8 // Hit slop for small buttons
export const HIT_SLOP_MEDIUM = 10 // Hit slop for medium buttons
